export function needsAiTag(image) {
  if (!image || image.ai_tag_result_id) return false;
  return Boolean(image.needs_ai_tag);
}

export function pendingReviewImages(images) {
  return (images || []).filter(image => Boolean(image.ai_tag_result_id));
}

export function selectedPendingReviewImages(images, selectedIds) {
  const selected = new Set(selectedIds || []);
  return pendingReviewImages(images).filter(image => selected.has(image.id));
}

export function selectedNeedsTagImages(images, selectedIds) {
  const selected = new Set(selectedIds || []);
  return (images || []).filter(image => selected.has(image.id) && needsAiTag(image));
}

export function filterAiWorkflowImages(images, mode) {
  if (mode === 'needs_tag') return (images || []).filter(needsAiTag);
  if (mode === 'review') return pendingReviewImages(images);
  return images || [];
}

export function editAiSuggestionFields(fields, field, values) {
  const next = {};
  for (const key of ['categories', 'major_tags', 'minor_tags', 'assistant_tags']) {
    next[key] = [...(fields?.[key] || [])];
  }
  next[field] = [...new Set((values || []).map(String))];
  return next;
}

export function imageIdsToRefreshAfterJob(requestedIds) {
  return [...new Set((requestedIds || []).map(String).filter(Boolean))];
}

const reviewFields = [
  ['categories', '分类'], ['major_tags', '主要标签'],
  ['minor_tags', '次要标签'], ['assistant_tags', '辅助标签'],
];
const sameTags = (a, b) => JSON.stringify([...new Set(a || [])].sort()) === JSON.stringify([...new Set(b || [])].sort());

export function aiReviewComparison(image) {
  if (!image?.ai_tag_result_id) return [];
  return reviewFields.map(([field, label]) => {
    const before = image.ai_review?.original_fields?.[field] ?? image[field] ?? [];
    const after = image.ai_applied_fields?.[field] ?? before;
    const raw = image.ai_review?.raw_suggested_fields?.[field];
    const suggested = image.ai_review?.suggested_fields?.[field];
    return {field, label, before, after,
      changed: !sameTags(before, after),
      abstained: image.ai_review?.abstained_fields?.includes(field) || (Array.isArray(suggested) ? suggested.length === 0 : after.length === 0),
      corrected: Array.isArray(raw) && Array.isArray(suggested) && !sameTags(raw, suggested),
      raw: raw || [], suggested: suggested || [],
    };
  });
}

export function aiReviewReasons(image) {
  const rows = aiReviewComparison(image);
  const reasons = [];
  if (rows.some(row => row.corrected)) reasons.push('规则调整过建议');
  if (rows.some(row => ['categories', 'major_tags'].includes(row.field) && row.changed && row.before.length)) reasons.push('分类或主体将改变');
  if (rows.some(row => row.abstained)) reasons.push('存在未识别字段');
  return reasons;
}
